import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEventsGoals = {
    before: AppConstants.GOALS_SEARCH_START_LOADING,
    success: AppConstants.GOALS_SEARCH_SUCCESS,
    fail: AppConstants.GOALS_SEARCH_FAIL
};

const defEventsAdvertisers = {
    before: AppConstants.ADVERTISERS_SEARCH_LOADING_START,
    success: AppConstants.ADVERTISERS_SEARCH_SUCCESS,
    fail: AppConstants.ADVERTISERS_SEARCH_FAIL
};

const defEventsPeriods = {
    before: AppConstants.PERIODS_SEARCH_LOADING_START,
    success: AppConstants.PERIODS_SEARCH_SUCCESS,
    fail: AppConstants.PERIODS_SEARCH_FAIL
};

const defEventsOffers = {
    before: AppConstants.OFFERS_SEARCH_START_LOADING,
    success: AppConstants.OFFERS_SEARCH_SUCCESS,
    fail: AppConstants.OFFERS_SEARCH_FAIL
};

const defEventsConversion = {
    before: AppConstants.CONVERSION_SEARCH_START_LOADING,
    success: AppConstants.CONVERSION_SEARCH_SUCCESS
};

const defEventsConversionTotal = {
    before: AppConstants.CONVERSION_GET_TOTAL_LOADING,
    success: AppConstants.CONVERSION_GET_TOTAL_SUCCESS
};

const defEventsFinanceOperation = {
    before: AppConstants.FINANCE_OPERATION_SEARCH_START_LOADING,
    success: AppConstants.FINANCE_OPERATION_SEARCH_SUCCESS
};

const defEventsPaymentDetails = {
    before: AppConstants.PAYMENT_DETAILS_SEARCH_START_LOADING,
    success: AppConstants.PAYMENT_DETAILS_SEARCH_SUCCESS,
};

const PublisherActions = {

    getPublisher(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchPublisher(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeType(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeType(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeLink(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeLink(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeContainer(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeContainer(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeBanner(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeBanner(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeLanding(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeLanding(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativePromoCode(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativePromoCode(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getOffers(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchOffers(params)
        .then(data => {
            events.success && dispatch({
                type  : events.success,
                items : data.response || {}
            });

            callback && callback(data.response);
        })
        .catch(err => {
            handleError(err, () => {
                dispatch({
                    type: events.fail,
                    error: err
                });
            });
        });
    },

    getGoals(params, callback, events = defEventsGoals) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchGoals(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getRanks() {
        api.getPublisherRanks()
            .then(data => {
                dispatch({
                    type  : AppConstants.PUBLISHER_RANKS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PUBLISHER_RANKS_LOAD_FAIL,
                        error: err
                    });
                });
            });
    },

    getContactTypes() {
        api.getContactTypes()
            .then(data => {
                dispatch({
                    type  : AppConstants.PUBLISHER_CONTACT_TYPES_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PUBLISHER_CONTACT_TYPES_LOAD_FAIL,
                        error: err
                    });
                });
            });
    },

    // getGoalEntries(params, callback) {
    //     dispatch({
    //         type  : AppConstants.GOAL_ENTRIES_SEARCH_LOADING_START
    //     });
    //
    //     return api.searchGoalEntries(params)
    //         .then(data => {
    //             dispatch({
    //                 type  : AppConstants.GOAL_ENTRIES_SEARCH_SUCCESS,
    //                 items : data.response || {}
    //             });
    //
    //             callback && callback();
    //         })
    //         .catch(err => {
    //             handleError(err, () => {
    //                 dispatch({
    //                     type: AppConstants.GOAL_ENTRIES_SEARCH_FAIL,
    //                     error: err
    //                 });
    //             });
    //         });
    //
    // },

    getAdvertisers(params, callback, events = defEventsAdvertisers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchAdvertisers(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getPeriods(params, callback, events = defEventsPeriods) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchPeriods(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    edit(params) {
        return api.editPublisher(params);
    },

    // getAccountEntries(params) {
    //     dispatch({
    //         type  : AppConstants.ACCOUNT_ENTRIES_START_LOADING
    //     });
    //
    //     return api.searchAccountEntries(params)
    //         .then(data => {
    //             dispatch({
    //                 type  : AppConstants.ACCOUNT_ENTRIES_SEARCH_SUCCESS,
    //                 items : data.response || {}
    //             });
    //         })
    //         .catch(err => {
    //             handleError(err);
    //         });
    // },

    getPaymentDetails(params, events = defEventsPaymentDetails) {
        dispatch({
            type  : events.before
        });

        return api.searchPublisherPaymentDetails(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });
    },

    getConversions(params, callback, events = defEventsConversion) {
        dispatch({
            type  : events.before
        });

        return api.searchConversions(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    getTotalRows(params, callback, events = defEventsConversionTotal) {
        dispatch({
            type  : events.before
        });

        return api.searchConversionTotalRows(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                PublisherActions.getConversions(params);

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    getFinanceOperations(params, callback, events = defEventsFinanceOperation) {
        dispatch({
            type  : events.before
        });

        return api.searchFinanceOperations(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    sendActivationCode(params) {
        dispatch({
            type  : AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_START_LOADING
        });

        return api.sendActivationCodePublisherPaymentDetails(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_FAIL,
                        error: err
                    });
                });
            });
    },
};

export default PublisherActions;
